module.exports = __webpack_public_path__ + "img/churchofGodlogo.1563c664.png";